'use client'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/style.css'

function CalendarDropdown({
  className,
  classNames,
  components,
  disabled,
  onChange,
  options = [],
  value,
  ...props
}) {
  return (
    <Select
      disabled={disabled}
      value={value?.toString()}
      onValueChange={(nextValue) =>
        onChange?.({ target: { value: nextValue } })
      }
    >
      <SelectTrigger
        className={cn(
          'min-w-19 h-9 w-fit gap-2 border-slate-700 bg-neutral-blue-900 px-3 py-2 text-base font-semibold text-slate-50 ring-offset-neutral-blue-800 hover:bg-neutral-blue-700 focus:ring-slate-300 [&>span]:leading-none',
          className,
        )}
        {...props}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="z-60 border-slate-700 bg-neutral-blue-900 p-1 text-slate-50 shadow-2xl">
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value.toString()}
            disabled={option.disabled}
            className="text-base font-medium text-slate-50 hover:bg-neutral-blue-700 focus:bg-neutral-blue-700 focus:text-slate-50 data-[state=checked]:bg-neutral-blue-700 data-[state=checked]:text-slate-50"
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

function Calendar({
  className,
  classNames,
  components,
  selected,
  onSelect,
  showOutsideDays = true,
  startMonth,
  endMonth,
  ...props
}) {
  return (
    <DayPicker
      animate
      mode="single"
      selected={selected}
      onSelect={onSelect}
      {...props}
      captionLayout="dropdown"
      defaultMonth={selected || new Date()}
      showOutsideDays={showOutsideDays}
      startMonth={startMonth}
      endMonth={endMonth}
      className={cn('p-3', className)}
      classNames={classNames}
      components={{ ...components, Dropdown: CalendarDropdown }}
    />
  )
}
Calendar.displayName = 'Calendar'

export { Calendar }
